import React, {FC} from 'react';

import {SettingsResourcePagesEnum, SettingsSignaturesUrl} from '../../models/url/settingsUrlModel';
import {SettingsPanelId} from '../../store/panels/panelStateBase';
import {SignatureCreateForm} from './form/signatureCreateForm';
import {SignatureEditForm} from './form/signatureEditForm';
import {SettingsSignaturesListContainer} from './settingsSignaturesListContainer';

interface SettingsSignaturesProps {
  panelId: SettingsPanelId;
  url: SettingsSignaturesUrl;
}

export const SettingsSignatures: FC<SettingsSignaturesProps> = ({panelId, url}) => {
  const {resourcePage, signatureId} = url;

  if (resourcePage === SettingsResourcePagesEnum.EDIT && signatureId) {
    return <SignatureEditForm signaturesUrl={url} signatureId={signatureId} panelId={panelId} />;
  }

  if (resourcePage === SettingsResourcePagesEnum.NEW) {
    return <SignatureCreateForm signaturesUrl={url} panelId={panelId} />;
  }

  if (resourcePage === SettingsResourcePagesEnum.OVERVIEW) {
    return <SettingsSignaturesListContainer signaturesUrl={url} />;
  }

  return null;
};
